/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Photo chooser UI
//
// Links photo chooser react UI with the page

import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';
import { EventEmitter } from '../event_emitter';
import { PhotoChooser as PhotoChooserComponent } from '../react/photo_chooser.jsx';

namespace('Slzr.UI', function(exports, top) {
  let jQuery;
  const $ = (jQuery = Slzr.jQuery);

  const Cls = (exports.PhotoChooser = class PhotoChooser extends EventEmitter {
    static initClass() {
      this.prototype.default_options = {
        // Dummy photo record
        photo:      {},
        // React element
        element:    null,
        // Target URL for uploads
        upload_url: "/photos/upload",
        // URL to retrieve library contents from
        library_url:"/photos/library",
        // Active photo aspect ratio
        aspect: 1,
        // Allow cropping
        cropping: true,
        // Allow uploading
        uploading: true,
        // Allow choosing
        library: true,
        // Allow removal
        remove: true,
        // Always allow cropping
        force_cropping: false,
        // Crop area name
        crop_area_name: 'default',
        // Crop area param name
        crop_area_param: 'photo[crop_areas]',
        // Show adjust cropping link
        show_crop_editor_link: true,
        // Show editor link
        show_editor_link: true
      };
    }

    constructor(options) {
      super(options);

      this.options = $.extend({}, this.default_options, options);

      ReactDOM.render(React.createElement(PhotoChooserComponent, {
            initial_photo:  this.options.photo,
            upload_url:     this.options.upload_url,
            library_url:    this.options.library_url,
            aspect:         this.options.aspect,
            can_choose:     this.options.library,
            can_remove:     this.options.remove,
            can_upload:     this.options.uploading,
            can_crop:       this.options.cropping,
            force_cropping: this.options.force_cropping,
            crop_area_name: this.options.crop_area_name,
            crop_area_param: this.options.crop_area_param,
            showCropEditorLink: this.options.show_crop_editor_link,
            showEditorLink: this.options.show_editor_link,
            allowCaptionEdit: this.options.allow_caption_edit,
            requireCaption: this.options.require_caption,
            captionLabel: this.options.caption_label,
            aiAltTextEnabled: this.options.ai_alt_text,
            aiAltTextAnalyticsCategory: this.options.alt_text_analytics_category,
            aiAltTextBtnClass: this.options.alt_text_btn_class,
            aiAltTextFieldClass: this.options.alt_text_field_class,
            aiAltTextModalBtnClasses: this.options.alt_text_modal_btn_classes
          }
          ),
          this.options.element.get(0));
    }
  });
  Cls.initClass();

  // Activate instance manager if the page says so
  return $(function() {
    const $elements = $('[data-photo-chooser="chooser"]');
    if (!($elements.length > 0)) { return; }

    // This needs FormData for uploads, so just completely disable (leaving a lone upload field) if it isn't supported
    if (!window.FormData) { return; }

    $elements.each(function() {
      let cropping; let library; let photo_data; let remove; let uploading;
      const $element = $(this);

      // Set default aspect ratio based on current theme, defaulting to square
      const photo_aspect_ratio = $element.data('photo-aspect') === 'image' ?
        -1
      :
        Number($element.data('photo-aspect')) || LOCALIST_SETTINGS.photo_aspect_ratio || 1.0;

      // Only enable functions specified in data-photo-chooser-enable, or enable
      // everything if not specified.
      if ($element.data("photo-chooser-enable")) {
        const parts = $element.data("photo-chooser-enable").split(/\s+/);
        library = parts.indexOf('library') > -1;
        remove = parts.indexOf('remove') > -1;
        uploading = parts.indexOf('upload') > -1;
        cropping = parts.indexOf('crop') > -1;
      } else {
        library = true;
        remove = true;
        uploading = true;
        cropping = true;
      }

      const force_cropping = !!$element.data('photo-chooser-always-allow-crop');
      const crop_area_name = $element.data('photo-chooser-crop-area-name');
      const crop_area_param = $element.data('photo-chooser-crop-area-param');
      const show_crop_editor_link = $element.data('photo-chooser-show-crop-editor-link');
      const show_editor_link = $element.data('photo-chooser-show-editor-link');
      const allow_caption_edit = $element.data('photo-chooser-allow-caption-edit');
      const require_caption = !!$element.data('photo-chooser-require-caption');
      const caption_label = $element.data('photo-chooser-caption-label') || null;
      const ai_alt_text = !!$element.data('photo-chooser-ai-alt-text');
      const alt_text_analytics_category = $element.data('photo-chooser-analytics-category') || null;
      const alt_text_btn_class = $element.data('photo-chooser-alt-text-btn-class') || null;
      const alt_text_field_class = $element.data('photo-chooser-alt-text-field-class') || null;
      const alt_text_modal_btn_classes = $element.data('photo-chooser-alt-text-modal-btn-classes') || {};

      // If crop data is specified (as an array of x,y,w,h), override it in the photo metadata
      const crop_data = $element.data('photo-crop');

      if (crop_data) {
        photo_data = _.extend({}, Slzr.Meta['photo-data']);
        photo_data['crop'] = {
          x: crop_data[0],
          y: crop_data[1],
          w: crop_data[2],
          h: crop_data[3]
        };
      } else {
        photo_data = Slzr.Meta['photo-data'] || {};
      }


      return top.photo_chooser = new Slzr.UI.PhotoChooser({
        element:        $element,
        photo:          photo_data,
        aspect:         photo_aspect_ratio,
        library,
        remove,
        uploading,
        cropping,
        force_cropping,
        crop_area_name,
        crop_area_param,
        show_crop_editor_link,
        show_editor_link,
        allow_caption_edit,
        require_caption,
        caption_label,
        ai_alt_text,
        alt_text_analytics_category,
        alt_text_btn_class,
        alt_text_field_class,
        alt_text_modal_btn_classes
      });
    });

    // Disable drops on the entire page
    $(document.body).on('dragover', function(event) {
      try {
        event.originalEvent.dataTransfer.dropEffect = 'none';
      } catch (err) {
        // Silently eat errors
        true;
      }

      return event.preventDefault();
    });

    return $(document.body).on('drop', event => event.preventDefault());
  });
});
